import { StyledInput } from './Input.style';

interface Props {
    type?: string
    id?: string
    name?: string
    value?: string
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    placeholder?: string
    checked?: boolean
    hasError?: boolean
    maxLength?: number
    onFocusCapture?: React.FocusEventHandler<HTMLInputElement>
    onBlur?: React.FocusEventHandler<HTMLInputElement>
}

const Input: React.FC<Props> = ({ type = 'text', id, name, value, onChange, placeholder, checked, hasError, maxLength, onFocusCapture, onBlur}) => {
    return (
        <StyledInput
            type={type}
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            checked={checked}
            hasError={hasError}
            maxLength={maxLength}
            onFocusCapture={onFocusCapture}
            onBlur={onBlur}
        />
    );
};

export default Input;